/**
 * Builds the route used to enter quick purchase.
 * @param {object} params - Quick purchase URL params.
 * @param {string} params.departureId - Departure trip id.
 * @param {string} [params.returnId] - Return trip id.
 * @param {string} [params.passengersParam] - Passenger selection param.
 * @param {string|number} [params.seenPrice] - Price shown before checkout.
 * @param {Array<string>} [params.seatNumbers] - Selected seat numbers.
 * @param {string} [params.couponCode] - Search coupon code.
 * @returns {string} Quick purchase route.
 */
export default function buildQuickPurchasePath({
  departureId,
  returnId = '',
  passengersParam = 'A1',
  seenPrice = '',
  seatNumbers = [],
  couponCode = '',
}) {
  const basePath = returnId
    ? `/purchase/${departureId}/${returnId}/quick/${passengersParam}`
    : `/purchase/${departureId}/quick/${passengersParam}`;
  const queryParams = new URLSearchParams();

  if (seenPrice) queryParams.set('seenPrice', seenPrice);
  if (seatNumbers?.length) queryParams.set('seats', seatNumbers.join(','));
  if (couponCode) queryParams.set('coupon', couponCode);

  const queryString = queryParams.toString();

  return queryString ? `${basePath}?${queryString}` : basePath;
}
